import { LinearProgress } from "@mui/material";
import { belowMinimum, formatPrice } from "../shopApi";
import styles from "../shop.module.css";

// "Add £X more to reach the £30 minimum", with progress; nothing once the minimum is met
const MinOrderNotice = ({ cart }) => {
  if (!belowMinimum(cart)) return null;
  const min = Number(cart.min_order);
  const subtotal = Number(cart.subtotal || 0);
  return (<div className={styles.MinOrder} role="status">
    <span>Add <strong>{formatPrice(min - subtotal)}</strong> more to reach the {formatPrice(min)} minimum order.</span>
    <LinearProgress variant="determinate" value={Math.min(100, (subtotal / min) * 100)} className={styles.MinOrderBar} />
  </div>);
};

export default MinOrderNotice;
